module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "chap_no"
  }, [_c('span', [_vm._v("III")])]), _vm._v(" "), _c('p', [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THOUGHT")]), _vm._v(" I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEARD")]), _vm._v(" the odd cawing of a bird lost in a sudden gathering dusk. It was a sound that was as forlorn as it was terrified. In the next second, I thought perhaps I had heard only my sigh and the beginning of a gasp. There began to seep into me a sadness beyond my sorrow at the death of my beloved Count, a sadness I knew I had felt before that, from a long time back, but whose object I had not even wondered about.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I knew then that Madame Bernice was right. I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" lived all those lives. I had not been dreaming. Memories of all those various existences fused for me out of the chaos of what I had thought were fragments of disturbed dreams. I remembered! My Adam rubbed his eyes when he saw me standing on a bed of orchids, as if he were asserting that I did not exist only within his vision. Still, now in another garden, Madame Bernice’s garden, I forcefully attempted to pull back from this enormity. “But in the present. . .?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Madame looked down again into her hands — they are large, sturdy hands for such a genteel woman. Again, she changed rings from one finger to another, the pearl in place of a ruby, the amethyst where a diamond had been. Her face beamed with a gracious smile. “Why, Lady, obviously in the present you’re the great Lady in hiding in the country because of dangers surrounding the murder of the Count du Muir. You’re the beautiful Lady whose company I share” — she stood, one hand extended graciously — “and whom I now invite to tea.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I took her hand, easily. Ermenegildo led us along the impeccable lawn toward her château.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("As we walked, I exulted in the luxuriance of her garden. “Oh, Madame, the beauty of your garden.”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“And it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" all mine,” Madame proclaimed her territory with a stout swirl of her hand. Ermenegildo seemed to bristle. The askew feather on his comb shook. “It is all "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ours,”")]), _vm._v(" she revised. “But — since we are egalitarians —” She touched Ermenegildo’s comb, avoiding the odd feather — as if for agreement, which I suspected he had given, because she continued: “— since we are egalitarians, we shall share it with whoever loves beauty.” She said all that with disarming genuineness.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well then, it has been waiting for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me!")]), _vm._v("”"), _c('em', {
    staticClass: "italic"
  }), _vm._v(" I felt almost dizzy, as if I were spinning, whirling — No, it was — I’m striving for exactitude to convey this powerful, strange sensation — it was as if a memory were trying to locate "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me.")]), _vm._v(" A memory of what? I wondered, as I felt surrounded by this bliss of colors and sweet scents in Madame’s garden. Careful designs of cultivated flowers wound through carpets of wild blooms so that the garden assumed a spectacular order all its own. Hyacinths! Hibiscus! Violets! Roses of every tint and color! Azaleas, freesias, daffodils, poppies, lilies, chrysanthemums, peonies! Orchids, tinted purple, others white and edged with gold! Acacias, hydrangeas! And willows, birches, elms, oak trees, eucalyptuses! A pepper tree! All melded into a profusion of leaves and shades of green, blue, silver.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And overlooking it all — but from a distance, at the periphery of the garden, where it slopes into the road that connects her château to mine — loomed palm trees.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("On Madame’s grand veranda, which we had reached, the balusters were draped by various vines that formed a tapestry of leaves and blossoms, mostly rivulets of bougainvillea.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("We sat at a sculpted table on which an impeccable tea setting awaited us. In a splendid vase one single blue rose exhibited itself. Madame must have signaled for the tea to be arranged while we had been conversing on the bench. She has the invisible manners that come only from breeding, manners exhibited even as she showed Ermenegildo, as if for his approval, the tiny cups into which she was about to serve our tea. A grand selection of tea cakes were the reason, Madame explained, why she was taking her tea later than usual: One of her cooks had intended to delight her with those cakes, which require added preparation. Shaped like puffy stars, they evaporated the moment they touched one’s lips.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("“A breath of Heaven, aren’t they?” Madame complimented them after we were seated and she had poured our tea — and had taken one of the pastries — all with impeccable grace. “I could become addicted")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v(" to them; so I must have only one more.” She popped it into her mouth. “You, Lady, have no problem with your weight, whereas I —”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“— have none either,” I pleased her by saying and thus unintentionally encouraged her to take yet another of the heavenly puffs.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("We sipped silently, allowing the new setting to adjust to our conversation, and we to it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was then that I noticed, on the table, a pair of exquisite opera glasses, adorned with miniature pearls. They seemed ready to be used, not forgotten from another time. It would have been rude to notice them further, and I would have looked away, had not Madame reached for them — they must have been already focused — and fixed her gaze on —")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The mansion next to mine,” Madame said, “has been only recently taken by a new tenant — perhaps just for the season.” The marked casualness in her voice extended. “I believe I first observed him soon after, or just about the same time, perhaps just before I saw "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("your")]), _vm._v(" carriage, Lady, dashing by to your own mansion.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I was certain Madame Bernice had determined that I attach significance to this matter. She still peered through her opera glasses. “The new tenant stands before his mansion often,” she said. “I’ve never really had a clear view of him because he locates himself under the eaves of his balcony. I’m more familiar with his shadow than with him! Oh, he’s there now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A wave of fear was stilled by the mere fact that I was with Madame. I felt "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("protected.")]), _vm._v(" But I had remembered this: During my flight here from the Grand Cathedral, I had noted that one of the châteaus down the road — surely the “mansion” Madame referred to — was just then being occupied. Trunks were being carried in from a coach. The new tenant, a tall presence — I remembered him vividly now; no, I, too, had seen only his elongated shadow — had waited on the outside stairs. Madame put down her glasses. She announced peremptorily: “On to important matters we’ve kept pending and which I shall now explain entirely. Your essence —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I received the word with a frown. Hadn’t she heard me earlier? “I am not a mystic.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She continued as if I had not spoken. “Your essence has been roaming for centuries from the past into the present.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I was sure I would grasp all this eventually. Now I only listened — to her, yes, but to other voices, traces of whispers out of my dreams.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("“It is the essence of all those women you thought you were")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v(" dreaming about that has moved into the beautiful body you now possess.” Madame sniffed at her tea, a special import sent to her by messenger weekly from the City. “In the Cathedral, when Irena shouted the word ‘whore’ —”")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“— the word swirled in terrified echoes within the Cathedral.” I was now certain of it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes,” Madame accepted. “It was then that your essence was aroused to manifest itself into this time, this life. To bring you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("here,")]), _vm._v(" for us to meet.” She spoke those last words quietly, and then went on: “You are now both present body and timeless essence. That essence is on its journey of redemption, to redeem with the truth the unjust blame on all those women. You are involved in nothing less than correcting the undeserved judgments of history.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I was taken aback by the breadth of the matter. I did not know until I heard her answer that I had spoken my thoughts aloud, without accepting what she had said. “But why me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Madame cocked her head. “Because it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" you.” She fed some crumbs from her delectable tea cakes to Ermenegildo — she’s clearly "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("extremely")]), _vm._v(" fond of him. He had demanded her attention by holding for the longest time imaginable an ostentatious display of feathers.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I was catching up with Madame’s deductions now, but not accepting them, of course. “And that is why I know — yes, even this — yes! — I know about the War in Heaven, and about —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That is enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The harsh words jarred me. I protested any possibility that they had been intended to contradict: “I am committed to the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Who knows that better than I?” Madame reminded me, and explained: “I stopped you only because we must begin immediately to plan for the announcement of these stunning revelations.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Announcement?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Madame Bernice looked at me as if my question baffled her, as if she assumed that if a thought entered her mind, it had managed to enter that of her listener. “Yes, to those to whom you must tell your story and who will spread it until everybody knows it. We must rehearse!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Rehearse!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“For interviews.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Interviews!”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("As if realizing only now that her thoughts had "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" entered mine,")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v(" Madame touched my hand briefly. “Lady, yours is not an ordinary story. It must be presented carefully.”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nothing about me is ordinary.” Was a part of me still struggling to thwart the words that would define my long journey?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Madame held up a finger for attention. An emerald embraced it. “It must be presented carefully” — she sighed, leaning over as if addressing Ermenegildo — “must be presented carefully and at last.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Surely he had not echoed her sigh? Had I?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Interviewers will be skeptical,” Madame moved on, “they’ll even attempt to deride your truths. There are several questions we ourselves must answer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("before")]), _vm._v(" we can proceed to present our cause. You must rehearse, rehearse, rehearse, rehearse.” She paused to allow me to catch up with her racing mind.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I could not.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She tried to make her voice sound casual, but that only drew even more attention to her astounding words: “There may well be forceful — and dangerous — attempts to thwart our interviews.” She had reached absently for her opera glasses. Her words resumed their previous authority: “In deference to your repeated assertion —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Was she going to indicate that she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" heard my repeated interjection that I am not a mystic? Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“— I shall say only that from the moment I glimpsed you earlier sitting on my bench and weeping, and soon after when you told me — so touchingly, Lady — the details of what you believed were dreams, I knew the time had come.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The time has come,” I uttered solemnly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Madame’s hand extended across the table toward mine. “I shall devote myself to ensure that you achieve your wondrous goal.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“My goal?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Her words came with a passion I had not detected earlier: “To redirect blame where it belongs” — she held her breath, and touched her heart — “and to purge the word . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She waited again for me to supply it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Whore!”")])])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Never in the City — I suppose because of its hectic social pace and the increasing duties required of the genteel within a crumbling society — had I noticed, that I recall, that there are moments when time pauses, when a moment is exposed, yes, naked, as if to be seen from every single vantage in order for its full meaning to be understood. Such a moment occurred after Madame had, with what now")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v(" seemed to me to have been a wounded sigh, uttered — no, after "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" had uttered — I was no longer sure who had finally spoken it — the word, “whore,” a moment that allowed such close scrutiny that I noticed that the leaves on a tree whose branches hovered over the veranda had changed color, become the slightest tint darker. An indiscernible breeze, contained in the same second, must have breathed on the leaves because their original hue returned immediately, just as Ermenegildo looked up, as if he, too, had noted the transformation.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("The moment passed. That is, it flowed into the remainder of the afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“By redefining that word,” and now it was definitely Madame who was speaking, “we shall defuse it, so that whoever says ‘whore’ hereafter shall evoke — redeemed! — all unjustly blamed women from the beginning of time.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("My eyes filled with tears.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Tears will add conviction.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I reared back from her startling insensitivity. “There is no need for forced tears. There have been too many real ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Excellently stated!” Madame congratulated. “I was preparing you for the skepticism you will face.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I was relieved that I had misinterpreted her words, that I had not given my trust easily. Was I catching her excitement? The next thought was like an ambush, though I didn’t know by what exactly: “But, Madame, surely in the interviews that you suggest” — I had chosen the word carefully so she would not infer agreement — “I would be asked how Eve connects with Helen —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The question of connections will come up,” she accepted easily. “That’s why rehearsals are essential. For now, let’s just observe that Eve is the first woman.” She popped another of the puffy stars into her mouth for punctuation.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" begun to catch her excitement. “And so Medea, too —” The dark memory demanded to be included.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Medea!”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("I would have interpreted the sudden wave of Madame’s hand as outraged rejection had I not noticed in relief that the gesture had slipped — though carefully — into a pushing away of a strand of her hair that was arguing with a breeze. She smiled, erasing — I had begun to read her signals — any hint of dissent between us, at least for now. She sipped her tea. “I do believe I shall reorder this blend, it’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("good.")]), _vm._v("”"), _c('em', {
    staticClass: "italic"
  }), _vm._v(" Was she still trying to move me away from that")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v(" deeply haunting, haunted life? She touched Ermenegildo’s comb, smoothed its crooked feather, which instantly recovered its curve. She leaned back, carefully positioning herself for greatest comfort in her chair. “Now, Lady, tell me how it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("all")]), _vm._v(" began, the creation of the world.”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("I remembered it exactly, and I said:")])])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ba2ff47","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_03.vue
// module id = 90
// module chunks = 0